import ApiService from './api';
import {
    Inspection,
    CreateInspectionRequest,
    UpdateInspectionRequest,
    InspectionSummary,
    VehicleStatus,
} from '../types';

export class InspectionService {
    async getInspections(params: {
        workshop_id: number;
        skip?: number;
        limit?: number;
        vehicle_id?: number;
        inspector_id?: number;
        inspection_type?: string;
        status?: string;
        date_from?: string;
        date_to?: string;
    }): Promise<Inspection[]> {
        return ApiService.get<Inspection[]>('/inspections', params);
    }

    async getInspectionById(id: number): Promise<Inspection> {
        return ApiService.get<Inspection>(`/inspections/${id}`);
    }

    async getVehicleInspections(
        vehicleId: number,
        params?: { skip?: number; limit?: number }
    ): Promise<Inspection[]> {
        return ApiService.get<Inspection[]>(
            `/inspections/vehicle/${vehicleId}`,
            params
        );
    }

    async createInspection(
        inspectionData: CreateInspectionRequest
    ): Promise<Inspection> {
        return ApiService.post<Inspection>('/inspections', inspectionData);
    }

    async updateInspection(
        id: number,
        inspectionData: UpdateInspectionRequest
    ): Promise<Inspection> {
        return ApiService.put<Inspection>(`/inspections/${id}`, inspectionData);
    }

    async deleteInspection(id: number): Promise<{ message: string }> {
        return ApiService.delete<{ message: string }>(`/inspections/${id}`);
    }

    async completeInspection(
        id: number,
        passed: boolean
    ): Promise<{ message: string }> {
        return ApiService.post<{ message: string }>(
            `/inspections/${id}/complete?passed=${passed}`
        );
    }

    async getInspectionSummary(): Promise<InspectionSummary> {
        return ApiService.get<InspectionSummary>('/inspections/stats/summary');
    }

    async getVehiclesStatus(): Promise<VehicleStatus[]> {
        return ApiService.get<VehicleStatus[]>('/inspections/stats/vehicles-status');
    }
}

export default new InspectionService();